import "./style.less";

export default function SearchBarTimeDropdown() {
    return {
        restrict: "E",
        //require : '^searchBar',
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            $timeout,
            searchBarFactory,
            timeFactory
        ) {
            /**
             * Access parent Scope ( bad practice? )
             */
            // $scope = $scope.$parent;

            //$scope.mobiscrollInstance = mobiScrollFactory.mobiscrollInstance;

            // $rootScope.$on("changing-mobiscoll-wheel", function () {
            //     //avail params : event, wheelobj
            //     //console.log(wheelobj);
            // });
            //console.log($scope.mobiscrollInstance);

            /**
             * [useSelectedTime description]
             * @param  {[type]} oSearchCategory     [description]
             * @param  {[type]} oSearchType         [description]
             * @param  {[type]} oSearchCalender     [description]
             * @param  {[type]} oSearchTime         [description]
             * @param  {[type]} searchFilter        [description]
             * @return {[type]}                     [description]
             */
            $scope.useSelectedTime = function (oSearchTime) {
                // avail params :    oSearchCategory, oSearchType, oSearchCalender, oSearchTime, searchFilter

                var wheelVal = timeFactory.mobiscrollInstance.getVal();

                var wheelObj = timeFactory.timeSelectorModel.filter(function (
                    obj
                ) {
                    return obj.value == wheelVal;
                })[0];

                timeFactory.setHouseTimes(oSearchTime, wheelObj);

                $timeout(function () {
                    $scope.$apply(function () {
                        $scope.deactivateDropdown(oSearchTime);

                        if (
                            $scope.oSearchCategory.buffer.CategoryID == 0 &&
                            $scope.oSearchType.buffer.ID == -1
                        ) {
                            $scope.activateUITooltip_preventWideSearch();
                        } else {
                            searchBarFactory.searchBroadcast();

                            if ($scope.redirectToSearch) {
                                // UrlFactory.route();
                            }
                        }

                        // if ($location.$$path != "/search") {
                        //     $location.path("/search");
                        // }
                    });
                }, 350);
            };
        },
    };
}
